import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight, Calendar, UserPlus } from 'lucide-react';

export default function Hero() {
  return (
    <section className="relative h-[60vh] md:h-[75vh] min-[1200px]:h-[60vh] min-h-[400px] md:min-h-[500px] min-[1200px]:min-h-[450px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://assets.auxodev.dk/assets/3d56beb5-25cd-44c2-a35b-95780bd285dd/d76baeac-fac6-464f-b569-2832c3cbc82b.jpg" 
          alt="Hellerup Lægehus" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-slate-100/40" />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-100/95 via-slate-100/70 to-slate-100/30" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full">
        <div className="max-w-2xl">
          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="flex items-center gap-4 mb-4 md:mb-6"
          >
            <div className="h-[1px] w-12 bg-[#4b717a]" />
            <span className="text-[#4b717a] text-xs tracking-[0.4em] uppercase font-bold">Velkommen til klinikken</span>
          </motion.div>
          
          <motion.h1 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-4xl md:text-7xl font-sans font-medium text-black leading-tight tracking-tight mb-6 md:mb-8"
          >
            Velkommen til <br />
            Hellerup Lægehus
          </motion.h1>
          
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="text-slate-600 text-base md:text-xl leading-relaxed mb-8 md:mb-10 max-w-lg"
          >
            MinLæge app’en – din online kontakt til lægen
          </motion.p>

          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="flex flex-col sm:flex-row gap-4"
          >
            <a 
              href="https://www.besoeglaegen.dk/Login.aspx?ClinicId=009555" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-[#4b717a] hover:bg-[#3d5c64] text-white px-8 py-4 flex items-center justify-center gap-3 transition-all group"
            >
              <Calendar size={20} />
              <span className="text-sm tracking-widest font-bold uppercase">Selvbetjening</span>
              <ChevronRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </a>
            <a 
              href="https://www.besoeglaegen.dk/Login.aspx?ClinicId=009555" 
              target="_blank" 
              rel="noopener noreferrer"
              className="border border-slate-900 text-slate-900 px-8 py-4 flex items-center justify-center gap-3 transition-all"
            >
              <UserPlus size={20} />
              <span className="text-sm tracking-widest font-bold uppercase">Opret dig</span>
            </a>
          </motion.div>
        </div>
      </div>

    </section>
  );
}
